import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IChecklistNominateApprover } from './IChecklistNominateApprover'

type NominatedUser = {
  name: string
  id: number
  company: string
  companyId?: number
}

// An already-nominated approver for a checklist's current approval step. Mirrors
// PermitNominateApprover but carries the bare targetApprovalId (no stage/label).
export class ChecklistNominateApprover extends Entity<IChecklistNominateApprover> {
  nominatedBy: NominatedUser

  targetApprovers: Array<NominatedUser>

  targetApprovalId: string

  public static new(payload: unknown): ChecklistNominateApprover {
    const entity = plainToInstance(ChecklistNominateApprover, payload)

    return entity
  }
}
